import type { Currency } from '@src/types';
import { format, toBigWithDefault } from '@src/utils/number';
import type { WritableDraft } from 'immer';
import { type ReactNode, useMemo } from 'react';

const quickButtonItems: Array<{ value: '0.25' | '0.5' | '0.75' | '1'; label: ReactNode }> = [
  {
    label: '25%',
    value: '0.25',
  },
  {
    label: '50%',
    value: '0.5',
  },
  {
    label: '75%',
    value: '0.75',
  },
  {
    label: 'Max',
    value: '1',
  },
];

export function useSwapQuickButtons(
  fromMaxAvailable: string | undefined,
  currencyDetails: {
    minIncrement: string;
    defaultIncrement: string;
    currency: Currency | WritableDraft<Currency> | undefined;
  } | null
) {
  const pct = useMemo(
    () =>
      ({
        '0.25': format(toBigWithDefault(fromMaxAvailable, 0).mul(0.25).toString(), {
          round: false,
          spec: currencyDetails?.minIncrement,
          pretty: false,
          truncate: true,
        }),
        '0.5': format(toBigWithDefault(fromMaxAvailable, 0).mul(0.5).toString(), {
          round: false,
          spec: currencyDetails?.minIncrement,
          pretty: false,
          truncate: true,
        }),
        '0.75': format(toBigWithDefault(fromMaxAvailable, 0).mul(0.75).toString(), {
          round: false,
          spec: currencyDetails?.minIncrement,
          pretty: false,
          truncate: true,
        }),
        '1': format(fromMaxAvailable, {
          round: false,
          spec: currencyDetails?.minIncrement,
          pretty: false,
          truncate: true,
        }),
      }) as const,
    [fromMaxAvailable, currencyDetails?.minIncrement]
  );

  return { quickButtonItems, pct };
}
